import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { TokenService } from '@core/services/token/token.service';
import { NonprofitAdminService } from '@core/services/nonprofit-admin.service';
import { TermsOfServiceService } from '@core/services/terms-of-service.service';

/**
 * Guard to protect routes from unauthenticated users.
 * @param route
 * @param state
 * @returns
 */
export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const tokenService = inject(TokenService);
  const nonprofitAdminService = inject(NonprofitAdminService);
  const termsOfServiceService = inject(TermsOfServiceService);

  const alreadyLoggedInWithBbid = route.queryParamMap.get('alreadyLoggedInWithBbid') == 'true';
  const isBbid = tokenService.isBbid;

  // Don't login with BBID twice if we already signed in
  if ((isBbid) && !alreadyLoggedInWithBbid) {
    const passed = await authService.loginWithBbid(false, false, false, null, null);

    // Don't continue if BBID login was unsuccessful
    if (!passed) {
      return false;
    }
  }

  if (!tokenService.getIsLoggedIn()) {
    router.navigateByUrl('login');

    return false;
  }

  if (!tokenService.tokenInfo) {
    await tokenService.fetchUserClaims();
  }

  // Terms of service logic
  if (!await termsOfServiceService.getUserTermsOfServiceModal()) {
    return false;
  }

  // Not internal admin but npo admin logic
  if (!authService.isInternalAdmin() && !await nonprofitAdminService.confirmNpoAdmin()) {
    return false;
  }

  return true;
}
